<template>
  <div class="page-template">
    <div class="page-title">{{ title }}</div>
     <search-form-template
           ref="storeTemplate"
          :searchOptions="storeSearchOptions"
          :toolConfig="toolConfig"
           @searchSubmit="searchSubmit"
           @clear="clearSearch"
           @btnCommon="btnCommon"
        ></search-form-template>
     <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="按门店" name="store" >
             <div class="echartsArea">
                <echarts-template class="charts-box" ref="storeAnalyseEcharts"
                                  :picOption="storeAnalyseEcharts">
                </echarts-template>
             </div>
      </el-tab-pane>

      <el-tab-pane label="按商品分类" name="category">
             <div class="echartsArea">
               <echarts-template class="charts-box-category" ref="categoryAnalyseEcharts"
                                 :picOption="categoryAnalyseEcharts">
               </echarts-template>
             </div>
      </el-tab-pane>
       <el-tab-pane label="按商品品牌" name="brand">
              <div class="echartsArea">
                <echarts-template class="charts-box-category" ref="brandAnalyseEcharts"
                                  :picOption="brandAnalyseEcharts">
                </echarts-template>
             </div>
      </el-tab-pane>
      <el-tab-pane label="按供应商" name="merchant">
        <div class="echartsArea">
          <echarts-template class="charts-box-category" ref="merchantAnalyseEcharts"
                            :picOption="merchantAnalyseEcharts">
          </echarts-template>
        </div>
      </el-tab-pane>
       <el-tab-pane label="按导购员" name="guide">
              <div class="echartsArea">
                <echarts-template class="charts-box-category" ref="guideAnalyseEcharts"
                                  :picOption="guideAnalyseEcharts">
                </echarts-template>
             </div>
      </el-tab-pane>
       <el-tab-pane label="按收银员" name="cashier">
              <div class="echartsArea">
                <echarts-template class="charts-box-category" ref="cashierAnalyseEcharts"
                                  :picOption="cashierAnalyseEcharts">
                </echarts-template>
             </div>
      </el-tab-pane>
       <el-tab-pane label="按支付方式" name="payment">
              <div class="echartsArea">
                <echarts-template class="charts-box-category" ref="paymentAnalyseEcharts"
                                  :picOption="paymentAnalyseEcharts">
                </echarts-template>
             </div>
      </el-tab-pane>
       <el-tab-pane label="按是否会员" name="member">
              <div class="echartsArea">
                <echarts-template class="charts-box-category" ref="memberAnalyseEcharts"
                                  :picOption="memberAnalyseEcharts">
                </echarts-template>
             </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import api from '@/config/api'
  import searchFormTemplate from '@/components/template/searchFormTemplate';
  import echartsTemplate from "@/components/controls/echarts";
  import {
    brandAnalyseEcharts,
    cashierAnalyseEcharts,
    categoryAnalyseEcharts,
    guideAnalyseEcharts,
    memberAnalyseEcharts,
    merchantAnalyseEcharts,
    paymentAnalyseEcharts,
    storeAnalyseEcharts
  } from "@/page/home/options/saleReportEcharts";
  import userPower from "@/mixin/userPower";

  export default {
  mixins: [userPower],
    components: { searchFormTemplate,echartsTemplate },
   created(){
       this.setStore(this.storeSearchOptions.simple);
       this.getStoreAnalyse(this.param),
       this.getCategoryAnalyse(this.param),
       this.getBrandAnalyse(this.param),
       this.getGuideAnalyse(this.param),
       this.getCashierAnalyse(this.param),
       this.paymentAnalyse(this.param),
       this.memberAnalyse(this.param),
       this.merchantAnalyse(this.param),
       this.allStore()
   },
   mounted(){
       this.title = document.title;
   },
   data(){
      let stCreateDttm = this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
      let edCreateDttm = this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
      let defaultParam = { stCreateDttm: stCreateDttm, edCreateDttm: edCreateDttm};
       return{
           param: defaultParam,
           title:"",
           activeTab:"store",
           storeAnalyseEcharts,
           categoryAnalyseEcharts,
           brandAnalyseEcharts,
           guideAnalyseEcharts,
           cashierAnalyseEcharts,
           paymentAnalyseEcharts,
           memberAnalyseEcharts,
           merchantAnalyseEcharts,
           storeSearchOptions:{
             simple:[
               {
                 label: '门店名称',
                 prop: 'storeId',
                 type: 'select',
                 data: []
               },
               {
                label: '选择日期',
                prop: "createDttms",
                type: "datetimeRange",
                dateType: "datetime",
                span: 24
             },

             ]
           },
           toolConfig:[
            {
                label: "导出",
                code: "export",
                callback:this.exportData
             },
           ]
       }
   },
   methods:{
      tabChange(){

      },
       //按门店
       getStoreAnalyse(param){
           this.$axios.fetchPost(api.report.storeAnalyseEcharts,param).then(data => {
        if (data.code == 200) {
           this.storeAnalyseEcharts.charsOption.series[0].data = [];
            data.data.map(item=>{
              this.storeAnalyseEcharts.charsOption.series[0].data.push({
                    name:item.storeName,
                    value:item.amountReceived,
                    goodsNum:item.goodsNum,
                    retailPrice:item.retailPrice,
                    orderNum:item.orderNum,
                    profit:item.profit,
                    businessRate:item.businessRate
              });
              this.storeAnalyseEcharts.charsOption.legend.data.push(item.storeName)
              if ((data.data.amountReceived = 0)) {
                this.storeAnalyseEcharts.charsOption.series[0].data = [];
              }
            })
            this.$nextTick(() => {
                this.$refs.storeAnalyseEcharts.drawpic();
            });
        }
      }).catch(err => {
        this.$message({message: '请求失败！', type: 'error'})
      })
       },
       //按商品分类
       getCategoryAnalyse(param){
           this.$axios.fetchPost(api.report.categoryAnalyseEcharts,param).then(data => {
        if (data.code == 200) {
          if(data.data.length ==0){
              this.categoryAnalyseEcharts.charsOption.title.text = "暂未查询到相关记录";
              this.categoryAnalyseEcharts.charsOption.title.top='center'
              this.categoryAnalyseEcharts.charsOption.title.right='center'
              this.categoryAnalyseEcharts.charsOption.series[0].data = [{}];
          }else{
              this.categoryAnalyseEcharts.charsOption.title.text = '占比统计（营业额） -商品分类 ';
              this.categoryAnalyseEcharts.charsOption.title.top = 5
              this.categoryAnalyseEcharts.charsOption.title.right = 0
              this.categoryAnalyseEcharts.charsOption.series[0].data = [];
            data.data.map(item=>{
              this.categoryAnalyseEcharts.charsOption.series[0].data.push({
                    name:item.goodsCategoryName,
                    value:item.amountReceived,
                    goodsNum:item.goodsNum,
                    retailPrice:item.retailPrice,
                    purchasePrice:item.purchasePrice,
                    businessRate:item.businessRate,
                    profit:item.profit,
                    profitRate:item.profitRate
              });
              this.categoryAnalyseEcharts.charsOption.legend.data.push(item.goodsCategoryName)
              if ((data.data.amountReceived = 0)) {
                this.categoryAnalyseEcharts.charsOption.series[0].data = [];
              }
            })
          }
            this.$nextTick(() => {
                this.$refs.categoryAnalyseEcharts.drawpic();
            });
        }
      }).catch(err => {
        this.$message({message: '请求失败！', type: 'error'})
      })
       },
       //按商品品牌
       getBrandAnalyse(param){
           this.$axios.fetchPost(api.report.brandAnalyseEcharts,param).then(data => {
        if (data.code == 200) {
          if(data.data.length==0){
              this.brandAnalyseEcharts.charsOption.title.text = "暂未查询到相关记录";
              this.brandAnalyseEcharts.charsOption.title.top='center'
              this.brandAnalyseEcharts.charsOption.title.right='center'
              this.brandAnalyseEcharts.charsOption.series[0].data = [{}];
          }else{
             this.brandAnalyseEcharts.charsOption.title.text = '占比统计（营业额） -商品品牌 ';
             this.brandAnalyseEcharts.charsOption.title.top = 5
             this.brandAnalyseEcharts.charsOption.title.right = 0
            this.brandAnalyseEcharts.charsOption.series[0].data = [];
            data.data.map(item=>{
              this.brandAnalyseEcharts.charsOption.series[0].data.push({
                    name:item.brandName,
                    value:item.amountReceived,
                    goodsNum:item.goodsNum,
                    retailPrice:item.retailPrice,
                    purchasePrice:item.purchasePrice,
                    businessRate:item.businessRate,
                    profit:item.profit,
                    profitRate:item.profitRate
              });
              this.brandAnalyseEcharts.charsOption.legend.data.push(item.brandName)
              if ((data.data.amountReceived = 0)) {
                this.brandAnalyseEcharts.charsOption.series[0].data = [];
              }
            })
          }
            this.$nextTick(() => {
                this.$refs.brandAnalyseEcharts.drawpic();
            });
        }
      }).catch(err => {
        this.$message({message: '请求失败！', type: 'error'})
      })
       },
       //按导购员
       getGuideAnalyse(param){
          let params={userType:50}
          let $params = Object.assign({},params,param);
           this.$axios.fetchPost(api.report.cashierAnalyseEcharts,$params).then(data => {
        if (data.code == 200) {
           if(data.data.length==0){
              this.guideAnalyseEcharts.charsOption.title.text = "暂未查询到相关记录";
              this.guideAnalyseEcharts.charsOption.title.top='center'
              this.guideAnalyseEcharts.charsOption.title.right='center'
              this.guideAnalyseEcharts.charsOption.series[0].data = [{}];
          }else{
              this.guideAnalyseEcharts.charsOption.title.text = "占比统计（营业额） -导购员";
              this.guideAnalyseEcharts.charsOption.title.top=5
              this.guideAnalyseEcharts.charsOption.title.right=0
               this.guideAnalyseEcharts.charsOption.series[0].data = [];
              data.data.map(item=>{
              this.guideAnalyseEcharts.charsOption.series[0].data.push({
                name: item.userName,
                    value:item.amountReceived,
                    orderNum:item.orderNum,
                    goodsNum:item.goodsNum,
                    retailPrice:item.retailPrice,
                    businessRate:item.businessRate,
                    profit:item.profit,
                    profitRate:item.profitRate
              });
              this.guideAnalyseEcharts.charsOption.legend.data.push(item.guideName)
              if ((data.data.amountReceived = 0)) {
                this.guideAnalyseEcharts.charsOption.series[0].data = [];
              }
            })
          }
            this.$nextTick(() => {
                this.$refs.guideAnalyseEcharts.drawpic();
            });
        }
      }).catch(err => {
        this.$message({message: '请求失败！', type: 'error'})
      })
       },
       //按收银员
       getCashierAnalyse(param){
           let params={userType:40}
           let $params = Object.assign({},params,param);
           this.$axios.fetchPost(api.report.cashierAnalyseEcharts,$params).then(data => {
        if (data.code == 200) {
          if(data.data.length==0){
              this.cashierAnalyseEcharts.charsOption.title.text = "暂未查询到相关记录";
              this.cashierAnalyseEcharts.charsOption.title.top='center'
              this.cashierAnalyseEcharts.charsOption.title.right='center'
               this.cashierAnalyseEcharts.charsOption.series[0].data = [{}];
          }else{
              this.cashierAnalyseEcharts.charsOption.title.text = "占比统计（营业额） -收银员";
              this.cashierAnalyseEcharts.charsOption.title.top=5
              this.cashierAnalyseEcharts.charsOption.title.right=0
              this.cashierAnalyseEcharts.charsOption.series[0].data = [];
            data.data.map(item=>{
              this.cashierAnalyseEcharts.charsOption.series[0].data.push({
                name: item.userName,
                    value:item.amountReceived,
                    orderNum:item.orderNum,
                    goodsNum:item.goodsNum,
                    retailPrice:item.retailPrice,
                    businessRate:item.businessRate,
                    profit:item.profit,
                    profitRate:item.profitRate
              });
              this.cashierAnalyseEcharts.charsOption.legend.data.push(item.cashierName)
              if ((data.data.memberCount = 0)) {
                this.cashierAnalyseEcharts.charsOption.series[0].data = [];
              }
            })
          }
            this.$nextTick(() => {
                this.$refs.cashierAnalyseEcharts.drawpic();
            });
        }
      }).catch(err => {
        this.$message({message: '请求失败！', type: 'error'})
      })
       },
       //按支付方式
       paymentAnalyse(param){
           this.$axios.fetchPost(api.report.paymentAnalyseEcharts,param).then(data => {
        if (data.code == 200) {
           this.paymentAnalyseEcharts.charsOption.series[0].data = [];
            data.data.map(item=>{
              this.paymentAnalyseEcharts.charsOption.series[0].data.push({
                    value:item.amountReceived,
                    name:item.payName,
                    orderNum:item.orderNum,
                    goodsNum:item.goodsNum,
                    retailPrice:item.retailPrice,
                    businessRate:item.businessRate,
                    profit:item.profit,
                    profitRate:item.profitRate
              });
              this.paymentAnalyseEcharts.charsOption.legend.data.push(item.payName)
              if ((data.data.amountReceived = 0)) {
                this.paymentAnalyseEcharts.charsOption.series[0].data = [];
              }
            })
            this.$nextTick(() => {
                this.$refs.paymentAnalyseEcharts.drawpic();
            });
        }
      }).catch(err => {
        this.$message({message: '请求失败！', type: 'error'})
      })
       },
       //按是否是会员
       memberAnalyse(param){
           this.$axios.fetchPost(api.report.memberAnalyseEcharts,param).then(data => {
        if (data.code == 200) {
          if(data.data.length==0){
              this.memberAnalyseEcharts.charsOption.title.text = "暂未查询到相关记录";
              this.memberAnalyseEcharts.charsOption.title.top='center'
              this.memberAnalyseEcharts.charsOption.title.right='center'
              this.memberAnalyseEcharts.charsOption.series[0].data = [{}];
          }else{
              this.memberAnalyseEcharts.charsOption.title.text = "占比统计（营业额） -是否会员";
              this.memberAnalyseEcharts.charsOption.title.top=5
              this.memberAnalyseEcharts.charsOption.title.right=0
              this.memberAnalyseEcharts.charsOption.series[0].data = [];
            data.data.map(item=>{
              this.memberAnalyseEcharts.charsOption.series[0].data.push({
                    value:item.amountReceived,
                    name:item.member,
                    orderNum:item.orderNum,
                    goodsNum:item.goodsNum,
                    retailPrice:item.retailPrice,
                    businessRate:item.businessRate,
                    profit:item.profit,
                    profitRate:item.profitRate
              });
              this.memberAnalyseEcharts.charsOption.legend.data.push(item.member)
              if ((data.data.amountReceived = 0)) {
                this.memberAnalyseEcharts.charsOption.series[0].data = [];
              }
            })
          }
            this.$nextTick(() => {
                this.$refs.memberAnalyseEcharts.drawpic();
            });
        }
      }).catch(err => {
        this.$message({message: '请求失败！', type: 'error'})
      })
       },
       //按供应商
       merchantAnalyse(param){
           this.$axios.fetchPost(api.report.merchantAnalyseEcharts,param).then(data => {
        if (data.code == 200) {
           if(data.data.length==0){
              this.merchantAnalyseEcharts.charsOption.title.text = "暂未查询到相关记录";
              this.merchantAnalyseEcharts.charsOption.title.top='center'
              this.merchantAnalyseEcharts.charsOption.title.right='center'
              this.merchantAnalyseEcharts.charsOption.series[0].data = [{}];
          }else{
             this.merchantAnalyseEcharts.charsOption.title.text = "占比统计（营业额） -供应商";
              this.merchantAnalyseEcharts.charsOption.title.top=5
              this.merchantAnalyseEcharts.charsOption.title.right=0
              this.merchantAnalyseEcharts.charsOption.series[0].data = [];
              data.data.map(item=>{
              this.merchantAnalyseEcharts.charsOption.series[0].data.push({
                    name:item.supplierName,
                    value:item.amountReceived,
                    goodsNum:item.goodsNum,
                    retailPrice:item.retailPrice,
                    purchasePrice:item.purchasePrice,
                    businessRate:item.businessRate,
                    profit:item.profit,
                    profitRate:item.profitRate
              });
              this.merchantAnalyseEcharts.charsOption.legend.data.push(item.supplierName)
              if ((data.data.amountReceived = 0)) {
                this.merchantAnalyseEcharts.charsOption.series[0].data = [];
              }
            })
          }
            this.$nextTick(() => {
                this.$refs.merchantAnalyseEcharts.drawpic();
            });
        }
      }).catch(err => {
        this.$message({message: '请求失败！', type: 'error'})
      })
       },
       allStore(){
          let mes=[]
          mes.unshift({name:"全部门店",value:""});
          this.$axios.fetchPost(api.system.seStore+'/list').then(data=>{
            if(data.code===200){
            data.data.unshift({name:"全部门店",value:""});
            this.storeSearchOptions.simple.filter(item=>item.prop==="storeId")[0].data=data.data;
          }
          })
       },
       searchSubmit() {
          let $payparams = Object.assign({}, this.params, this.$refs.storeTemplate.getSimpleParams());
          this.getStoreAnalyse($payparams);
          this.getCategoryAnalyse($payparams);
          this.getBrandAnalyse($payparams);
          this.merchantAnalyse($payparams);
          this.getGuideAnalyse($payparams);
          this.getCashierAnalyse($payparams);
          this.paymentAnalyse($payparams);
          this.memberAnalyse($payparams);
    },
       clearSearch() {
       let $payparams = Object.assign({},this.$refs.storeTemplate.getSimpleParams());
       console.log(this.params)
          this.getStoreAnalyse($payparams);
          this.getCategoryAnalyse($payparams);
          this.getBrandAnalyse($payparams);
          this.merchantAnalyse($payparams);
          this.getGuideAnalyse($payparams);
          this.getCashierAnalyse($payparams);
          this.paymentAnalyse($payparams);
          this.memberAnalyse($payparams);
    },
       btnCommon(btnObj) {
      btnObj.callback && btnObj.callback();
    },
    exportData(){
       const simpleParams = Object.assign({}, this.$refs.storeTemplate.getSimpleParams());
       let params
       let url;
       let fileName;
       let exportcode
      if (this.activeTab === "store") {
        url = api.report.storeAnalyseExport;
        fileName = '占比统计（营业额） -门店.xls';
        exportcode = {exportCode: 'SoBusinessStoreExport'}
      }
      if (this.activeTab === "category") {
        url = api.report.categoryAnalyseExport
        fileName = '占比统计（营业额） -商品分类.xls';
        exportcode = {exportCode: 'SoBusinessCategoryExport'}
      }
      if (this.activeTab === "brand") {
        url = api.report.brandAnalyseExport
        fileName = '占比统计（营业额） -商品品牌.xls';
        exportcode = {exportCode: 'SoBusinessBrandExport'}
      }
      if (this.activeTab === "merchant") {
        url = api.report.merchantAnalyseExport
        fileName = '占比统计（营业额） -供应商.xls';
        exportcode = {exportCode: 'SoBusinessSupplierExport'}
      }
      if (this.activeTab === "guide") {
        params = {userType: 50}
        url = api.report.cashierAnalyseExport
        fileName = '占比统计（营业额） -导购员.xls';
        exportcode = {exportCode: 'SoBusinessUserExport'}
      }
      if (this.activeTab === "cashier") {
        params = {userType: 40}
        url = api.report.cashierAnalyseExport
        fileName = '占比统计（营业额） -收银员.xls';
        exportcode = {exportCode: 'SoBusinessUserExport'}
      }
      if (this.activeTab === "payment") {
        url = api.report.paymentAnalyseExport
        fileName = '占比统计（营业额） -支付方式.xls';
        exportcode = {exportCode: 'SoBusinessPayExport'}
      }
      if (this.activeTab === "member") {
        url = api.report.memberAnalyseExport
        fileName = '占比统计（营业额） -是否会员.xls';
        exportcode = {exportCode: 'SoBusinessMemberExport'}
      }
      let $params = Object.assign({}, params, simpleParams, exportcode);
      this.$axios.fetchPost(url, $params).then(data => {
        if (data.code === 200) {
          const elink = document.createElement('a');
          elink.href = data.data;
          elink.click();
          this.loadingExt = false;
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '导出成功', type: 'success'});
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({message: '导出异常', type: 'error'});
        }
      })
    }
   },
}
</script>

<style scoped>
.echartsArea{
    height: 500px;
    width: 100%;
    background: #fff;
    border-radius: 8px;
    box-shadow: 3px 3px 3px #e5e5e5;
    padding: 10px;
    box-sizing: border-box;
}
.charts-box-category{
     height: 480px;
     width: calc(100vw - 140px);
}
</style>



// WEBPACK FOOTER //
// src/page/report/sales/Proportion.vue